import {
  Select as MuiSelect,
  type SelectProps as MuiSelectProps,
} from '@mui/material';
import { forwardRef } from 'react';

import type { BaseComponentProps } from '../utils/types';

export type { SelectChangeEvent } from '@mui/material';

type Props = Pick<
  MuiSelectProps,
  | 'fullWidth'
  | 'children'
  | 'value'
  | 'onChange'
  | 'disabled'
  | 'sx'
  | 'disableUnderline'
  | 'ref'
  | 'open'
  | 'onOpen'
  | 'labelId'
  | 'label'
  | 'size'
  | 'MenuProps'
  | 'name'
  | 'required'
  | 'onBlur'
  | 'variant'
  | 'IconComponent'
  | 'displayEmpty'
  | 'renderValue'
> &
  BaseComponentProps;

export const Select = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref) => {
    return (
      <MuiSelect {...props} ref={ref}>
        {children}
      </MuiSelect>
    );
  },
);
